import { Component, Input, OnInit } from '@angular/core';
import { EncryptDecryptService } from "../services/encrypt-decrypt.service";
import { HttpClient } from "@angular/common/http";
import { FormBuilder, FormGroup, Validators, FormControl } from "@angular/forms";
import { MatDialogRef } from "@angular/material/dialog";
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from "@angular/material/snack-bar";
import { VariablesGlobales } from '../services/globals';

@Component({
  selector: 'app-add-jobalert',
  templateUrl: './add-jobalert.component.html',
  styleUrls: ['./add-jobalert.component.css']
})
export class AddJobalertComponent implements OnInit {
  public controlForm: FormGroup;

  @Input() name: string;
  @Input() _mail: string;
  @Input() _jobalert_portable: string;

  apikey: string;
  user: any;
  jsonData: string;
  fonctionName: Fonction[];
  regionName: Region[];

  region: Region[] = [];
  emploiFonction: Fonction[] = [];

  horizontalPosition: MatSnackBarHorizontalPosition = 'center';
  verticalPosition: MatSnackBarVerticalPosition = 'top';

  constructor(public param: VariablesGlobales,
    private _snackBar: MatSnackBar,
    private encdec: EncryptDecryptService,
    private http: HttpClient,
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<AddJobalertComponent>) {
    this.controlForm = new FormGroup({
      nom: new FormControl(this.name, [
        Validators.required,
        Validators.maxLength(50)
      ]),
      email: new FormControl(this._mail, [
        Validators.required,
        Validators.pattern('(([^<>()\\[\\]\\\\.,;:\\s@"]+(\\.[^<>()\\[\\]\\\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))')
      ]),
      jobalert_portable: new FormControl(this._jobalert_portable, [
        Validators.nullValidator

      ]),
      fonctionName: new FormControl(this.fonctionName, [Validators.nullValidator]),
      regionName: new FormControl(this.regionName, [Validators.nullValidator]),
    });
  }
  get sms() { return this.controlForm.get('jobalert_portable'); }

  get email() { return this.controlForm.get('email'); }

  optionnal() {
    if (this.sms.valid)
      this.controlForm.controls['email'].validator = Validators.pattern('(([^<>()\\[\\]\\\\.,;:\\s@"]+(\\.[^<>()\\[\\]\\\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))');
    else
      this.controlForm.controls['email'].validator =
        Validators.compose([Validators.pattern('(([^<>()\\[\\]\\\\.,;:\\s@"]+(\\.[^<>()\\[\\]\\\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))'), Validators.required]);

    if (this.email.valid)
      this.controlForm.controls['jobalert_portable'].validator = Validators.pattern('(0|\\+33)[1-9]([-. ]?[0-9]{2}){4}');
    else
      this.controlForm.controls['jobalert_portable'].validator =
        Validators.compose([Validators.pattern('(0|\\+33)[1-9]([-. ]?[0-9]{2}){4}'), Validators.required]);

    this.controlForm.controls['email'].updateValueAndValidity();
    this.controlForm.controls['jobalert_portable'].updateValueAndValidity();
  }
  ngOnInit(): void {
    this.apikey = localStorage.getItem('apikey');
    this.user = JSON.parse(localStorage.getItem('currentUser'));
    this.controlForm.get('email').setValue(this.user.mail);
    this.controlForm.get('jobalert_portable').setValue(this.user.portable);
    this.getInfoJA();
  }

  getInfoJA() {
    let resp: string = "";
    this.http.get('https://api2.sitederecrutement.com/Home/getinfos?apikey=' + this.apikey, { responseType: "text" }).subscribe(
      result => {
        this.jsonData = this.encdec.getDecrypt(result);
        let jsonObject: any = JSON.parse(this.jsonData);

        this.emploiFonction = jsonObject.fonctions;
        this.region = jsonObject.regions;
      }
    )
  }

  onSubmit() {
    const obj: NewJobAlert = {
      idcandidat: this.user.idcandidat,
      jobalert_nom: this.controlForm.get('nom').value,
      jobalert_fonction: this.controlForm.get('fonctionName').value.map(d => d.fonction).toString(),
      jobalert_mail: this.controlForm.get('email').value,
      jobalert_region: this.controlForm.get('regionName').value.map(c => c.region).toString(),
      jobalert_portable: this.controlForm.get('jobalert_portable').value
    };

    // formattage data
    let data = this.encdec.getEncrypt(JSON.stringify(obj));
    const formData = new FormData();
    formData.append('datas', data);

    //envoi des données
    this.http.post('https://api2.sitederecrutement.com/Home/updatealerte?apikey=' + this.apikey, formData, { responseType: "text" }).subscribe(
      result => {
        this.dialogRef.close(true);
      }
    );
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}

interface Region {
  idregion: number;
  region: string;
}

interface Fonction {
  idfonction: number;
  fonction: string;
}

interface NewJobAlert {
  idcandidat: string;
  jobalert_nom: string;
  jobalert_fonction: string;
  jobalert_mail: string;
  //jobalert_contrat: string;
  jobalert_region: string;
  jobalert_portable: string;
}
